<template>
  <BaseModal
    ref="modal"
    modal-classes="max-w-md mx-auto mt-16"
    @modal-after-leave="$emit('closed')"
  >
    <template #header>
      <h3 class="text-2xl text-gray-900">Edit contact list</h3>
    </template>

    <template #default="modalProps">
      <PipelineForm
        :submit-action="submitAction"
        :default-data="pipeline"
        @cancel="modalProps.close"
      />
    </template>
  </BaseModal>
</template>

<script>
import { mapActions } from 'vuex';
import PipelineForm from '@/components/Pipelines/Form.vue';

export default {
  components: {
    PipelineForm,
  },

  props: {
    pipeline: { type: Object, required: true },
  },

  methods: {
    ...mapActions('ui/pipelines', {
      updatePipeline: 'update',
    }),
    submitAction(formData) {
      const { id: pipelineUuid } = this.pipeline;

      return this.updatePipeline({ pipelineUuid, formData })
        .then((response) => Promise.resolve(response))
        .catch((error) => Promise.reject(error));
    },
  },
};
</script>
